export default function Banner() {
    return (
        <div className="banner">
            <article className="article">
                <h1 className="mt-12">台灣公車動態</h1>
                <p className="mt-4 text-gray-200">時刻查詢系統</p>
                <p className="mt-5 text-gray-400 tracking-normal text-xs lg:text-sm">TAIWAN BUS+</p>
            </article>
        </div>
    )
}